export default "__VITE_ASSET__Dr6CCTwZ__"